import React from 'react'
import {Input} from "antd"

const InputSearch = (props) => {
    const {name, label, filters} = props

    const _handleChangeInput = (e) => {
        if (e.key === 'Enter') {
            const {name, value} = e.target
            let filtersElm = document.querySelector('.ReportByDayContainer .PageFilters')
            let stage = {}
            let inputElms = filtersElm.getElementsByTagName('input')
            for (let i = 0; i < inputElms.length; i++) {
                if (inputElms[i].getAttribute('name') !== null) {
                    stage[inputElms[i].getAttribute('name')] = inputElms[i].value
                }
            }
            const newStage = {
                ...filters,
                ...stage,
                page: 1,
                [name]: value
            }
            props.onChange(newStage)
        }
    }

    return (
        <div className="FilterSelect">
            <label htmlFor={name}>{label}</label>

            <Input
                id={name}
                name={name}
                placeholder='Gõ Enter để tìm kiếm'
                onKeyDown={_handleChangeInput}
                style={{width: "100%"}}
            />
        </div>
    )
}

export default InputSearch
